export default __webpack_public_path__ + "static/media/logo_site.96c3306c.png";